import { Celebrity } from '@/schema/celebrity';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface signUpUserState {
  email: string;
  verifyEmail?: string | undefined;
  provider: string;
  providerSub: string;
  providerSubConfirm?: string | undefined;
  nickname: string;
  agreeTerms: {
    ageAccepted: boolean;
    serviceAccepted: boolean;
    privacyAccepted: boolean;
    marketingAccepted: boolean;
  };
  favoriteCelebrities: Celebrity[];
}

const initialSignUpUserState: signUpUserState = {
  email: '',
  provider: '',
  providerSub: '',
  nickname: '',
  agreeTerms: {
    ageAccepted: false,
    serviceAccepted: false,
    privacyAccepted: false,
    marketingAccepted: false,
  },
  favoriteCelebrities: [],
};

const signUpUserSlice = createSlice({
  name: 'signUpUser',
  initialState: initialSignUpUserState,
  reducers: {
    setEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
    },
    setVerifyEmail: (state, action: PayloadAction<string | undefined>) => {
      state.verifyEmail = action.payload;
    },
    setProvider: (state, action: PayloadAction<string>) => {
      state.provider = action.payload;
    },
    setProviderSub: (state, action: PayloadAction<string>) => {
      state.providerSub = action.payload;
    },
    setProviderSubConfirm: (
      state,
      action: PayloadAction<string | undefined>,
    ) => {
      state.providerSubConfirm = action.payload;
    },
    setNickname(state, action: PayloadAction<string>) {
      state.nickname = action.payload;
    },
    setAgreeTerm(
      state,
      action: PayloadAction<{ name: string; checked: boolean }>,
    ) {
      state.agreeTerms[action.payload.name as keyof typeof state.agreeTerms] =
        action.payload.checked;
    },
    setAllAgreeTerms(state, action: PayloadAction<boolean>) {
      state.agreeTerms.ageAccepted = action.payload;
      state.agreeTerms.serviceAccepted = action.payload;
      state.agreeTerms.privacyAccepted = action.payload;
      state.agreeTerms.marketingAccepted = action.payload;
    },
    setFavoriteCelebrities(state, action: PayloadAction<Celebrity[]>) {
      state.favoriteCelebrities = action.payload;
    },
  },
});

export const {
  setEmail,
  setVerifyEmail,
  setProvider,
  setProviderSub,
  setProviderSubConfirm,
  setNickname,
  setAgreeTerm,
  setAllAgreeTerms,
  setFavoriteCelebrities,
} = signUpUserSlice.actions;

export default signUpUserSlice.reducer;
